import React, { Component } from 'react'

export default class Footer extends Component {
  render() {
    return <div>&copy; Prefab C</div>
  }
}
